<script>
import countryRegionData from 'country-region-data';
import get from 'lodash/get';
import each from 'lodash/each';
import find from 'lodash/find';
import sortBy from 'lodash/sortBy';
import isEqual from 'lodash/isEqual';
import vueMixins from 'viralstyle-ui/src/vueMixins';
import VsButton from 'viralstyle-ui/src/VsButton';
import VsButtonToggle from 'viralstyle-ui/src/VsButtonToggle';
import VsInput from 'viralstyle-ui/src/VsInput';
import VsSelect from 'viralstyle-ui/src/VsSelect';
import { mapState } from 'vuex';

import { paymentWireValidator } from '../_settings-validator';

export default {
  components: {
    VsInput,
    VsButton,
    VsButtonToggle,
    VsSelect,
  },
  mixins: [vueMixins],
  props: {
    hideSubmit: [Boolean, String],
  },
  data: () => ({
    paymentWireValidator,
    accountClientTypes: [{ text: 'Personal', value: 'PERSONAL' }, { text: 'Business', value: 'BUSINESS' }],
    allCountries: {},
  }),
  computed: {
    ...mapState({
      processing: state => state.processing,
      paymentInfo: state => state.settings.paymentInfo,
      paymentInfoSubmitted: state => state.settings.paymentInfoSubmitted,
      originalPaymentInfo: state => state.settings.originalPaymentInfo,
    }),
    regions() {
      let country = find(countryRegionData, country => country.countryShortCode === this.get(this.paymentInfo, 'wire_details.recipient_country')),
        regions = {};

      if (country) each(country.regions, region => regions[region.name] = region.name);

      return regions;
    },
    bankRegions() {
      let country = find(countryRegionData, country => country.countryShortCode === this.get(this.paymentInfo, 'wire_details.bank_country')),
        regions = {};

      if (country) each(country.regions, region => regions[region.name] = region.name);

      return regions;
    }
  },
  created() {
    paymentWireValidator.clear();

    each(sortBy(countryRegionData, 'name'), country => this.allCountries[country.countryShortCode] = country.countryName);

    if (this.originalPaymentInfo && !isEqual(this.paymentInfo.wire_details, this.originalPaymentInfo.wire_details)) {
      this.$store.commit('updateStateClone', { object: this.paymentInfo, property: 'wire_details', value: this.originalPaymentInfo.wire_details });
    }
  },
  updated() {
    this.$emit('update');
  },
  methods: {
    updatePaymentInfo(e, prop) {
      let value = get(e, 'target.value') !== undefined ? get(e, 'target.value') : e;
      this.$store.commit('updatePaymentInfo', { prop: `wire_details.${prop}`, value })
      paymentWireValidator.validate(prop, value);
    },
    updateRecipientCountry(e) {
      this.updatePaymentInfo(e, 'recipient_country');
      this.updatePaymentInfo(null, 'recipient_state');
    },
    updateBankCountry(e) {
      this.updatePaymentInfo(e, 'bank_country');
      this.updatePaymentInfo(null, 'bank_state');
    },
    async savePaymentMethod() {
      let valid = await paymentWireValidator.validateAll(this.paymentInfo.wire_details);
      if (valid) {
        this.$store.dispatch('savePaymentMethod', 'WIRE');
        this.$store.commit('updateState', { object: this.paymentInfoSubmitted, property: 'WIRE', value: false });
      } else {
        this.$store.commit('updateState', { object: this.paymentInfoSubmitted, property: 'WIRE', value: true });
      }
    },
  },
};
</script>

<template lang='pug'>
.accordion-content__client
  vs-input(type='text', full-width, placeholder='Recipient Full Name', :value='get(paymentInfo, "wire_details.recipient_name")',
    prevent-autofill,
    @input='updatePaymentInfo($event, "recipient_name")',
    :error='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("recipient_name")')
  .vs-error(v-show='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("recipient_name")')
    | {{paymentWireValidator.firstError('recipient_name')}}
  .payouts-settings__address
    vs-input(type='text', full-width, placeholder='Recipient Address', :value='get(paymentInfo, "wire_details.recipient_address")',
      prevent-autofill,
      @input='updatePaymentInfo($event, "recipient_address")',
      :error='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("recipient_address")')
    .vs-error(v-show='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("recipient_address")')
      | {{paymentWireValidator.firstError('recipient_address')}}
  .payouts-settings__apt
    vs-input(type='text', full-width, placeholder='Recipient Apt', :value='get(paymentInfo, "wire_details.recipient_apt")',
      prevent-autofill,
      @input='updatePaymentInfo($event, "recipient_apt")',
      :error='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("recipient_apt")')
    .vs-error(v-show='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("recipient_apt")')
      | {{paymentWireValidator.firstError('recipient_apt')}}
  vs-input(type='text', full-width, placeholder='Recipient City', :value='get(paymentInfo, "wire_details.recipient_city")',
    prevent-autofill,
    @input='updatePaymentInfo($event, "recipient_city")',
    :error='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("recipient_city")')
  .vs-error(v-show='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("recipient_city")')
    | {{paymentWireValidator.firstError('recipient_city')}}
  .payouts-settings__address
    vs-select(v-if='Object.keys(regions).length', key-value, placeholder='Recipient State / Province / Region', :value='get(paymentInfo, "wire_details.recipient_state") || null',
      prevent-autofill,
      @input='updatePaymentInfo($event, "recipient_state")', :options='regions',
      :error='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("recipient_state")')
    vs-input(v-else, full-width, type='text', placeholder='Recipient State / Province / Region',
      prevent-autofill,
      :value='get(paymentInfo, "wire_details.recipient_state")', @input='updatePaymentInfo($event, "recipient_state")')
    .vs-error(v-show='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("recipient_state")')
      | {{paymentWireValidator.firstError('recipient_state')}}
  .payouts-settings__apt
    vs-input(type='text', full-width, placeholder='Recipient Zip', :value='get(paymentInfo, "wire_details.recipient_zip")',
      prevent-autofill,
      @input='updatePaymentInfo($event, "recipient_zip")',
      :error='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("recipient_zip")')
    .vs-error(v-show='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("recipient_zip")')
      | {{paymentWireValidator.firstError('recipient_zip')}}
  vs-select(key-value, placeholder='Recipient Country', :value='get(paymentInfo, "wire_details.recipient_country") || null',
    prevent-autofill,
    @input='updateRecipientCountry', :options='allCountries',
    :error='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("recipient_country")')
  .vs-error(v-show='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("recipient_country")')
    | {{paymentWireValidator.firstError('recipient_country')}}

  vs-input(type='text', full-width, placeholder='Account Number', :value='get(paymentInfo, "wire_details.account_number")',
    prevent-autofill,
    @input='updatePaymentInfo($event, "account_number")',
    :error='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("account_number")')
  .vs-error(v-show='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("account_number")')
    | {{paymentWireValidator.firstError('account_number')}}
  vs-input(type='text', full-width, placeholder='Bank Routing Number', :value='get(paymentInfo, "wire_details.bank_routing")',
    prevent-autofill,
    @input='updatePaymentInfo($event, "bank_routing")',
    :error='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("bank_routing")')
  .vs-error(v-show='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("bank_routing")')
    | {{paymentWireValidator.firstError('bank_routing')}}
  vs-button-toggle(:options='accountClientTypes', :selected-option='get(paymentInfo, "wire_details.account_type")', @toggle='updatePaymentInfo($event, "account_type")')
  .vs-error(v-show='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("account_type")')
    | {{paymentWireValidator.firstError('account_type')}}

  vs-input(type='text', full-width, placeholder='Bank Name', :value='get(paymentInfo, "wire_details.bank_name")',
    prevent-autofill,
    @input='updatePaymentInfo($event, "bank_name")',
    :error='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("bank_name")')
  .vs-error(v-show='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("bank_name")')
    | {{paymentWireValidator.firstError('bank_name')}}
  vs-input(type='text', full-width, placeholder='Bank Address', :value='get(paymentInfo, "wire_details.bank_address")',
    prevent-autofill,
    @input='updatePaymentInfo($event, "bank_address")',
    :error='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("bank_address")')
  .vs-error(v-show='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("bank_address")')
    | {{paymentWireValidator.firstError('bank_address')}}
  vs-input(type='text', full-width, placeholder='Bank City', :value='get(paymentInfo, "wire_details.bank_city")',
    prevent-autofill,
    @input='updatePaymentInfo($event, "bank_city")',
    :error='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("bank_city")')
  .vs-error(v-show='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("bank_city")')
    | {{paymentWireValidator.firstError('bank_city')}}
  .payouts-settings__address
    vs-select(v-if='Object.keys(bankRegions).length', key-value, placeholder='Bank State / Province / Region', :value='get(paymentInfo, "wire_details.bank_state") || null',
      prevent-autofill,
      @input='updatePaymentInfo($event, "bank_state")', :options='bankRegions',
      :error='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("bank_state")')
    vs-input(v-else, full-width, type='text', placeholder='Bank State / Province / Region',
      prevent-autofill,
      :value='get(paymentInfo, "wire_details.bank_state")', @input='updatePaymentInfo($event, "bank_state")')
    .vs-error(v-show='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("bank_state")')
      | {{paymentWireValidator.firstError('bank_state')}}
  .payouts-settings__apt
    vs-input(type='text', full-width, placeholder='Bank Zip', :value='get(paymentInfo, "wire_details.bank_zip")',
      prevent-autofill,
      @input='updatePaymentInfo($event, "bank_zip")',
      :error='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("bank_zip")')
    .vs-error(v-show='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("bank_zip")')
      | {{paymentWireValidator.firstError('bank_zip')}}
  vs-select(key-value, placeholder='Bank Country', :value='get(paymentInfo, "wire_details.bank_country") || null',
    prevent-autofill,
    @input='updateBankCountry', :options='allCountries',
    :error='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("bank_country")')
  .vs-error(v-show='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("bank_country")')
    | {{paymentWireValidator.firstError('bank_country')}}
  vs-input(type='text', full-width, placeholder='Bank Swift Code', :value='get(paymentInfo, "wire_details.bank_swift_code")',
    prevent-autofill,
    @input='updatePaymentInfo($event, "bank_swift_code")',
    :error='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("bank_swift_code")')
  .vs-error(v-show='paymentInfoSubmitted.WIRE && paymentWireValidator.hasError("bank_swift_code")')
    | {{paymentWireValidator.firstError('bank_swift_code')}}

  vs-button(v-if='!hideSubmit', text='save', icon='content-save', :processing='processing',
    :disabled='processing', @click='savePaymentMethod')
</template>